// Grocery footer: the shared footer (which owns all runtime brand / outlet
// contact data), dressed in the grocery skin via the `gx-footer` wrapper.
// Phones skip it on the catalog pages (all products, category products,
// categories): those lists scroll infinitely, so a footer would sit
// under content that keeps growing.
import { Grid } from 'antd';
import { useLocation } from 'react-router-dom';
import FooterCommon from './FooterCommon.jsx';

export default function FooterGrocery() {
  const { pathname } = useLocation();
  const screens = Grid.useBreakpoint();
  // Same phone breakpoint as the catalog's infinite scroll (CatalogPage).
  const isPhone = Object.keys(screens).length > 0 && !screens.sm;

  if (isPhone && pathname.startsWith('/catalog')) return null;

  return (
    <div className="gx-footer">
      <FooterCommon />
    </div>
  );
}
